module.exports = __webpack_public_path__ + "img/776-f2d394.png";